import { render, staticRenderFns } from "./LoginProcessCard.vue?vue&type=template&id=38fd07e4&"
import script from "./LoginProcessCard.vue?vue&type=script&lang=ts&"
export * from "./LoginProcessCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/builds/intern/customer-portal/frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
installComponents(component, {VAlert,VBtn})
